import {AbstractControl, NG_VALIDATORS, Validator} from '@angular/forms';
import {Directive, Input} from '@angular/core';
import {System} from '../System';

@Directive({
	selector: '[emailFormat]',
	providers: [{provide: NG_VALIDATORS, useExisting: EmailFormatDirectiveValidator, multi: true}]
})
export class EmailFormatDirectiveValidator implements Validator {
	@Input('emailFormat') allowValidation = true;
	emailFormat = System.mailRegexp;

	validate(control: AbstractControl): {[key: string]: any} | null {
		return (typeof this.allowValidation != 'boolean' || this.allowValidation) && control.value && !control.value.toString().toLowerCase().match(this.emailFormat) ? {'emailFormat': control.value} : null;
	}
}